import { useState, useEffect } from 'react';

/**
 * Hook para detectar si el usuario está online o offline
 * Actualiza automáticamente cuando cambia el estado de la red
 */
export function useOnline() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        // El usuario acaba de reconectarse
        if (import.meta.env.DEV) console.log('📡 Conectado a internet - sincronizando datos...');
        // Trigger sync event
        window.dispatchEvent(new Event('online-sync'));
      }
      setWasOffline(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      if (import.meta.env.DEV) console.log('📴 Sin conexión - modo offline activo');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  return { isOnline, wasOffline };
}
